import { Button, Dropdown, Field, Option } from '@fluentui/react-components';

import { SEVERITY_LABEL, SEVERITY_ORDER, STATUS_LABEL, STATUS_ORDER } from '../../constants';
import { getCategories } from '../../helpers';
import { TFindingState, TFindingStatus, TReviewSeverity } from '../../types';
import { EMPTY_FINDING_FILTERS, hasActiveFilters, TFindingFilters } from '../../utils';

const ALL = 'all';
type TProps = { findings: TFindingState[]; filters: TFindingFilters; setFilters: (filters: TFindingFilters) => void };

export const FindingFilters = ({ findings, filters, setFilters }: TProps) => {
  const update = (partial: Partial<TFindingFilters>) => setFilters({ ...filters, ...partial });

  return (
    <div className="flex flex-wrap items-end gap-4">
      <Field label="Status">
        <Dropdown
          size="large"
          value={filters.status ? STATUS_LABEL[filters.status] : 'All statuses'}
          selectedOptions={[filters.status ?? ALL]}
          onOptionSelect={(_, data) =>
            update({ status: data.optionValue === ALL ? undefined : (data.optionValue as TFindingStatus) })
          }
        >
          <Option value={ALL}>All statuses</Option>
          {STATUS_ORDER.map((status) => (
            <Option key={status} value={status}>
              {STATUS_LABEL[status]}
            </Option>
          ))}
        </Dropdown>
      </Field>
      <Field label="Category">
        <Dropdown
          size="large"
          value={filters.category ?? 'All categories'}
          selectedOptions={[filters.category ?? ALL]}
          onOptionSelect={(_, data) => update({ category: data.optionValue === ALL ? undefined : data.optionValue })}
        >
          <Option value={ALL}>All categories</Option>
          {getCategories(findings).map((category) => (
            <Option key={category} value={category}>
              {category}
            </Option>
          ))}
        </Dropdown>
      </Field>
      <Field label="Severity">
        <Dropdown
          size="large"
          value={filters.severity ? SEVERITY_LABEL[filters.severity] : 'All severities'}
          selectedOptions={[filters.severity ?? ALL]}
          onOptionSelect={(_, data) =>
            update({ severity: data.optionValue === ALL ? undefined : (data.optionValue as TReviewSeverity) })
          }
        >
          <Option value={ALL}>All severities</Option>
          {SEVERITY_ORDER.map((severity) => (
            <Option key={severity} value={severity}>
              {SEVERITY_LABEL[severity]}
            </Option>
          ))}
        </Dropdown>
      </Field>
      {hasActiveFilters(filters) ? (
        <Button size="large" appearance="subtle" onClick={() => setFilters(EMPTY_FINDING_FILTERS)}>
          Clear
        </Button>
      ) : null}
    </div>
  );
};
